export const LOAD = 'ethstats/uncleCount/LOAD';
export const LOAD_SUCCESS = 'ethstats/uncleCount/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/uncleCount/LOAD_FAIL';
